import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

// React Final Form
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';


// Material Icons Imports
import IconContentSend from '@material-ui/icons/Send';
import IconContentReset from '@material-ui/icons/DeleteSweep';
import IconContentRemB from '@material-ui/icons/RemoveCircle';

// import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import { DatePicker } from 'material-ui-pickers';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// import components
import CustomLoader from './innerComponents/CustomLoader';

import SelectAutocomplete from './innerComponents/SelectAutocomplete';

import axios from 'axios';

import crypto from 'crypto';

import moment from 'moment';
// Assets imports
import '../styles/NewProject.css';


const styles = theme => ({
    root: {
        height: 250,
        flexGrow: 1,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    fieldStyle: {
        minHeight: "72px",
        width: "100%",
    },

    buttonStyle: {
        marginRight: 12,
    },

    paperStyle: {
        // General styles for paper
        width: "60%",
        margin: "0 auto",
        height: "auto",
    }
});

class CreateCertificate extends React.Component {

    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
    }

    state = {
        suggestions: [],
        // fileMsg: 'No file chosen',
        value: 0,
    };

    _certificationsItems(items) {
        return items.map((item, id) => (
            <MenuItem
                value={item.id}
                key={item.id}
            >{item.name}</MenuItem>
        ));
    }

    _usersItems(items) {
        return items.map((item, id) => (
            <MenuItem
                value={item.id}
                key={item.id}
            >{item.fullName} </MenuItem>
        ));
    }

    _reader(file) {
        var reader = new FileReader();
        return new Promise(res => {
            reader.onload = function () {
                res(this.result);
            }
            reader.readAsArrayBuffer(file);

        })
    }

    _uploadCertificate = async  values => {

        if (this.fileInput.current.value === "") {

        }

        const file = values.file

        const blob = new Blob([file])
        await this._reader(blob).then(
            arrayBuffer => {
                const array = new Uint8Array(arrayBuffer)
                // const binaryString = new TextDecoder("utf-8").decode(array);
                const hash = crypto.createHash('sha256');
                hash.update(array, 'utf-8');
                console.log(hash)
                const sha = hash.digest('hex');
                console.log(sha);

                const field = file.name.split('.')[0];
                const expiryDate = moment(values.expiryDate)
                expiryDate.set({ hour: 23, minute: 59, second: 59 })


                const query = `mutation{
                uploadCertificate(certificate: "${field}",
                    input: {
                    sha: "${sha}",
                    userId: ${values.userId},
                    certificationId: ${values.certificationId},
                    originalFileName: "${file.name}",
                    expiryDate: "${expiryDate.format('YYYY-MM-DDTHH:mm:ss.SSS')}"
                    }
                )
                }`;

                const multipart = new FormData();
                multipart.set('query', query);
                multipart.set(field, file, file.name);

                return axios.post(
                    process.env.REACT_APP_BACKEND_BASE_URL + '/api/graphql',
                    multipart,
                    {
                        headers: {
                            'Authorization': localStorage.getItem("token"),
                            'role': localStorage.getItem("current_user_role")
                        }
                    }
                )
            }
        ).then(
            ({ data }) => {
                console.log(data);
                if (data.errors && data.errors.length > 0) {
                    if (data.errors[0].message === "sha_user_id has already been taken") {
                        alert('The certificate already exists');
                    }
                } else {
                    alert("The Certificate was successfully uploaded")
                    this.props.history.push({
                        pathname: "/training/list",
                        state: { refetch: true,
                            onCertifications: false }
                    });
                }
            }
        ).catch(
            (error) => {
                alert("Error while upload certificate")
                console.log(error)
            }
        );

    }

    _resetForm(form) {
        form.reset();
        // this.setState({ fileMsg: 'No file chosen' })
        this.fileInput.current.value = "";

    }

    // componentDidMount(){
    //     this.props.all_users_query.refetch()
    //     .then(this.props.all_certifications_query.refetch())
    //     .then(console.log('refetched')
    //     ).catch(error => {
    //         console.log('error')
    //         console.log(error)
    //     });
    //   }


    render() {

        const required = value => (value ? undefined : 'Required field');

        const SelectAutocompleteAdapter = ({ input, meta, ...rest }) => (
            <SelectAutocomplete
                {...input}
                {...rest}
                input={input}
                error={meta.touched && meta.error !== undefined}
                helperText={meta.touched ? meta.error : ''}
            />
        );

        const DatePickerAdapter = ({ input, meta, ...rest }) => (
            <DatePicker
                {...input}
                {...rest}
                disableOpenOnEnter
                format="YYYY-MM-DD"
                invalidLabel=""
                onChange={(event) => input.onChange(event.format('YYYY-MM-DDTHH:mm:ss.SSS'))}
                error={meta.touched && meta.error !== undefined}
                helperText={meta.touched ? meta.error : ''}
            />
        );

        // Check if the query response is being loaded
        if (this.props.all_certifications_query && this.props.all_certifications_query.loading) {
            return <CustomLoader label={'Loading Certifications'}/>
        }

        // Check if there were errrors
        if (this.props.all_certifications_query && this.props.all_certifications_query.error) {
            return <div> Certifications Could not be loaded </div>
        }

        // Check if the query response is being loaded
        if (this.props.all_users_query && this.props.all_users_query.loading) {
            return <CustomLoader label={'Loading Users'}/>
        }

        // Check if there were errrors
        if (this.props.all_users_query && this.props.all_users_query.error) {
            return <div> Users could not be loaded </div>
        }

        const all_certifications = this.props.all_certifications_query.certifications
        console.log(all_certifications)

        const certificationSuggestions = all_certifications.map(certification => ({
            value: certification.id,
            label: certification.name
        }))

        const all_users = this.props.all_users_query.users

        const disableSelectUser = this.props.match.params.userId !== undefined



        const userSuggestions = all_users.map(user => ({
            value: user.id,
            label: user.fullName
        }))

        const { classes } = this.props;
        const tab = this.props.location.state? this.props.location.state.tab : 0;
        // const { fileMsg } = this.state;





        return (
            <Paper className={classes.paperStyle} elevation={1}>
                <div>
                    <Form
                        onSubmit={this._uploadCertificate}
                        initialValues={{ userId: this.props.match.params.userId,
                            filen: ''
                         }}
                        mutators={{
                            ...arrayMutators
                        }}
                        render={({ handleSubmit, submitting, pristine, values, form }) => (
                            <form onSubmit={handleSubmit}>

                                <div className="NewProject-header">
                                    <div className="NewProject-title">
                                        <span>New Certificate</span>
                                    </div>
                                    <div className="NewProject-actions">
                                        <Button
                                            color="primary"
                                            onClick={()=>this.props.history.push({
                                                pathname: "/training/list",
                                                state: { refetch: false,
                                                    tab: tab }
                                            })}
                                        ><IconContentRemB style={{ marginRight: 8 }} /> Cancel</Button>
                                    </div>
                                </div>

                                <div className="NewProject-content">
                                    <div>
                                        <Field
                                            name="certificationId"
                                            validate={required}
                                            mLabel="Certification"
                                            mValue={values["certificationId"]}
                                            component={SelectAutocompleteAdapter}
                                            placeholder="Type to search a certification"
                                            options={certificationSuggestions}
                                            className={classes.fieldStyle} />
                                    </div>
                                    <div>
                                        <Field
                                            name="userId"
                                            validate={required}
                                            component={SelectAutocompleteAdapter}
                                            mLabel="User"
                                            mValue={values["userId"]}
                                            placeholder="Type to search a user"
                                            options={userSuggestions}
                                            mDisabled={disableSelectUser}
                                            className={classes.fieldStyle} />
                                    </div>
                                    <div>
                                        <Field
                                            name="expiryDate"
                                            validate={required}
                                            component={DatePickerAdapter}
                                            label="Expiry Date"
                                            className={classes.fieldStyle}
                                        />
                                    </div>
                                    <Typography variant='body2' style={{ marginBottom: 8 + 'px' }}>File</Typography>
                                    <div style={{ marginBottom: '16px' }}>
                                        <input
                                            id="certificateFile"
                                            name="fileInput"
                                            type="file"
                                            onChange={(e) => {
                                                // this.setState({ fileMsg: e.target.files[0]?  e.target.files[0].name : 'No file chosen' })
                                                values['file'] = e.target.files[0]
                                            }}
                                            required
                                            // style={{display: 'none'}}
                                            ref={this.fileInput}
                                            accept="application/pdf, image/*"
                                        />
                                        {/* <label htmlFor="certificateFile">
                                            <span style={{ marginRight: '8px' }}>{fileMsg}</span>
                                            <Button variant="contained" component="span" size='small' color='primary'>
                                                <CloudUploadIcon style={{ marginRight: '8px' }} />
                                                Chose File
                                            </Button>
                                        </label> */}
                                    </div>
                                </div>

                                <div className="NewProject-detailFooter">
                                    <div className="buttons">

                                        <Button variant="contained"
                                            color="primary"
                                            type="submit"
                                            disabled={submitting || pristine}
                                            className={classes.buttonStyle}
                                        ><IconContentSend style={{ marginRight: 8 }} />Submit</Button>

                                        <Button variant="contained"
                                            type="button"
                                            color="secondary"
                                            onClick={this._resetForm.bind(this, form)}
                                            disabled={submitting || pristine}
                                            className={classes.buttonStyle}
                                        ><IconContentReset style={{ marginRight: 8 }} /> Reset</Button>

                                    </div>
                                </div>

                            </form>
                        )}
                    />
                </div>
            </Paper>
        );
    }
}

CreateCertificate.propTypes = {
    classes: PropTypes.object.isRequired,
};


const ALL_CERTIFICATIONS_QUERY = gql`
    query{
        certifications{
        id
        name
        }
    }
`;

const ALL_USERS_QUERY = gql`
  query {
    users(filters: [{field: "active_eq" operand: "true"}]){
      id
      fullName
      role
      email
    }
  }
`;

export default compose(
    graphql(ALL_USERS_QUERY, { name: 'all_users_query' }),
    graphql(ALL_CERTIFICATIONS_QUERY, { name: 'all_certifications_query' })
)(withStyles(styles)(CreateCertificate));


// WEBPACK FOOTER //
// src/components/CreateCertificate.js